import React from "react";
import { Link } from "react-router-dom";
import logo from "../logo.svg";
import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa";

const Navbar = () => {
  return (
    <nav className="navbar">
      <nav className="nav-center">
        <Link to="/">
          <img src={logo} alt="logo" className="logo" />
        </Link>
        <ul className="nav-links">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/about">about</Link>
          </li>
          <li>
            <a href="https://www.facebook.com/shahzaib.chaudary.50/">
              {<FaFacebook />}
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/ssup_shahzaib/?hl=en">
              {<FaInstagram />}
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/channel/UCdwMIWK33eP2Ksmb9P5c1OA/featured">
              {<FaYoutube />}
            </a>
          </li>
        </ul>
      </nav>
    </nav>
  );
};

export default Navbar;
